import { Bounds } from 'google-map-react'

export enum SetBoundsType {
  OnMove = 'on_move',
  OnRequest = 'on_request',
}

interface ISetBounds {
  label: string
  onChangeBounds: (bounds: Bounds) => void
}

export interface ISetBoundsOnMove extends ISetBounds {
  __typename: SetBoundsType.OnMove
  enabled: boolean
  onChangeEnabled: (enabled: boolean) => void
}

export interface ISetBoundsOnRequest extends ISetBounds {
  __typename: SetBoundsType.OnRequest
}

export type SetBounds = ISetBoundsOnMove | ISetBoundsOnRequest
